import { render, staticRenderFns } from "./PwdResetComplete.vue?vue&type=template&id=71d97d6e&"
import script from "./PwdResetComplete.vue?vue&type=script&lang=ts&"
export * from "./PwdResetComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports